/**
 * HTML body for the password-reset OTP email, sent as `OTPContent` on
 * POST /v1/witmeg/otp/request.
 *
 * The literal `<OTP>` token is a placeholder the Org Registry service replaces
 * with the generated code — leave it exactly as-is.
 */
export function buildPasswordResetOtpEmail({ name, email }) {
  // The template greets the user by name; before login all we have is the email,
  // so fall back to its local part ("dulana@x.com" -> "dulana").
  const displayName = name || (email || "").split("@")[0] || "there";

  return `<html>

            <head>
                <link href='https://fonts.googleapis.com/css?family=Inter' rel='stylesheet'>
                <style>
                    html {
                        font-family: 'Inter', sans-serif;
                        font-size: 16px;
                    }

                    .font-12 {
                        font-size: 12px !important;
                        font-weight: 500 !important;
                    }

                    .email-container div {
                        width: 50%;
                        background-color: #fff;
                        border: 1px solid rgba(0, 0, 0, 0.1);
                        padding: 30px;
                        border-radius: 5px;
                    }

                    .image-container {
                        background-image: url("../Desktop/email-logo-lg.png");
                        width: 200px;
                        height: 100px;
                        background-repeat: no-repeat;
                        border: none !important;
                        background-color: transparent !important;
                    }

                    .verification-code {
                        background-color: #1E5781 !important;
                        color: #fff;
                        width: fit-content !important;
                        padding: 10px !important;
                        border-radius: 4px;
                        margin: auto;
                        letter-spacing: 5px;
                        white-space: nowrap;
                    }

                    .mb-24 {
                        margin-bottom: 24px;
                    }

                    .mb-50 {
                        margin-bottom: 50px;
                    }

                    .mt-50{
                        margin-top: 50px;
                    }

                    .mr-10{
                        margin-right: 10px;
                    }

                    .email {
                        color: #2A77B0;
                    }

                    .email-template {
                        width: 610px;
                        margin: auto;
                        line-height: 32px;
                    }

                    .email-template td {
                        padding: 20px;
                    }

                    .text-center {
                        text-align: center;
                    }

                    .bg {
                        background-color: #F3F4F5;
                    }

                    .email-template .white-bg {
                        background-color: #F3F4F5 !important;
                    }
                    .bottom-line{
                        border-top: 1px solid #DFE1E2;
                        padding-top: 20px;
                    }
                </style>
            </head>

            <body>
                <div>
                    <table class="email-template" cellspacing="0">
                        <tbody>
                            <tr>
                                <td class="white-bg"></td>
                                <td class="text-center bg">
                                    <img src="https://cdn.neurolage.com/witmeg/apps/witmeg/Witmeg_Big_Logo.png" class="mb-50 mt-50"/></td>
                                <td class="white-bg"></td>
                            </tr>
                            <tr>
                                <td class="white-bg"></td>
                                <td><b class="mb-50">Hello ${displayName},</b></td>
                                <td class="white-bg"></td>
                            </tr>
                            <tr>
                                <td class="white-bg"></td>
                                <td>You recently requested to reset your password for your WITMEG Account. <span
                                        class="email">(${email})</span>
                                    Please enter below verification code to reset it.</td>
                                <td class="white-bg"></td>
                            </tr>
                            <tr>
                                <td class="white-bg"></td>
                                <td class="text-center">
                                    <div class="verification-code"><OTP></div>
                                </td>
                                <td class="white-bg"></td>
                            </tr>
                            <tr>
                                <td class="white-bg"></td>
                                <td>If you didn't request this, you can ignore this email.<br /></td>
                                <td class="white-bg"></td>
                            </tr>
                            <tr>
                                <td class="white-bg"></td>
                                <td><span class="bottom-line" style="color: #000;">Thank you !</span><br />WITMEG Team</td>
                                <td class="white-bg"></td>
                            </tr>
                            <tr>
                                <td class="white-bg"></td>
                                <td class="text-center bg">
                                    <img src="https://cdn.neurolage.com/witmeg/apps/witmeg/Witmeg_Small_Logo.png" />
                                    <p class="font-12"><b>Need help?</b> <span class="email"><b><a>FAQ</a> |<a>Email Us</a> | <a>Help Center</a></b></span>
                                    </p>
                                    <div>
                                        <img src="https://cdn.neurolage.com/witmeg/socialmedia/sm-facebook.png" class="mr-10"/>
                                        <img src="https://cdn.neurolage.com/witmeg/socialmedia/sm-ln.png" class="mr-10"/>
                                        <img src="https://cdn.neurolage.com/witmeg/socialmedia/sm1.png"/>
                                    </div>
                                    <p class="font-12">Copyright &copy; 2022 WITMEG , all rights reserved</p>
                                </td>
                                <td class="white-bg"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </body>

            </html>`;
}
